import { TOfferType } from '@cian/api-models/offer-card/v1/get-offer-data';

export const getEstimationTitle = (offerType: TOfferType) => {
  switch (offerType) {
    case 'flat':
      return 'Оценка этой квартиры от Циан';
    case 'suburban':
      return 'Оценка этого участка от Циан';
    default:
      return 'Оценка этой недвижемости от Циан';
  }
};
